import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import JMeterUI from "@/jmeter"

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(JMeterUI);
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    kv: {},
    interval: 5000
  }
})

new Vue({
  el: '#app', render: h => h(App), store: store
})
